import type { Meta } from '../../data/types';
import { formatLargeInt } from '../../lib/format';
import styles from './MetricsStrip.module.css';

interface MetricsStripProps {
  meta: Meta;
}

interface Metric {
  label: string;
  value: string;
  note?: string;
}

export function MetricsStrip({ meta }: MetricsStripProps) {
  const metrics: Metric[] = [
    {
      label: 'Families tracked',
      value: formatLargeInt(meta.total_models),
      note: `${meta.ranked_models} ranked, ${meta.tracked_insufficient_evidence_models} held back`,
    },
    {
      label: 'Twitter mentions scored',
      value: formatLargeInt(meta.total_scored_mentions),
      note: `${formatLargeInt(meta.total_about_mentions)} about-family`,
    },
    {
      label: 'Bootstrap iterations',
      value: formatLargeInt(meta.bootstrap_iterations),
      note: '95% intervals on every score',
    },
    {
      label: 'Issue',
      value: String(meta.week).padStart(2, '0'),
      note: 'one-week artifact',
    },
  ];

  return (
    <section className={styles.strip} aria-label="Weekly readout summary">
      <dl className={styles.list}>
        {metrics.map((m) => (
          <div className={styles.cell} key={m.label}>
            <dt className={styles.label}>{m.label}</dt>
            <dd className={styles.value}>{m.value}</dd>
            {m.note ? <p className={styles.note}>{m.note}</p> : null}
          </div>
        ))}
      </dl>
    </section>
  );
}
